import * as React from 'react';

import { default as SvgIcon } from './SvgIcon.js';

/**
 * Autogenerated react component for icon ClassroomDuotone
 */
export const ClassroomDuotone = React.forwardRef((props: any, ref: any) => (
  <SvgIcon
    ref={ref}
    viewBox="0 0 256 256"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <style type="text/css">{'.st0{opacity:0.2;}'}</style>
    <path
      d="M46.7,84.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C34.5,90.4,40,84.9,46.7,84.9 M46.7,74.9c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2S69,109.4,69,97.1S59,74.9,46.7,74.9z"
      fill="currentColor"
    />
    <path
      d="M127.7,84.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C115.5,90.4,121,84.9,127.7,84.9 M127.7,74.9c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S140,74.9,127.7,74.9z"
      fill="currentColor"
    />
    <path
      d="M209.7,84.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C197.5,90.4,203,84.9,209.7,84.9 M209.7,74.9c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S222,74.9,209.7,74.9z"
      fill="currentColor"
    />
    <path d="M227.5,27.6v23h-199v-23H227.5 M237.5,17.6h-219v43h219V17.6z" fill="currentColor" />
    <path className="st0" d="M227.5,27.6v23h-199v-23H227.5" fill="currentColor" />
    <path
      d="M46.7,203.9c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0C34.5,209.4,40,203.9,46.7,203.9  M46.7,193.9c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2S59,193.9,46.7,193.9L46.7,193.9z"
      fill="currentColor"
    />
    <path
      d="M127.7,203.9c6.8,0,12.3,5.5,12.3,12.2s-5.5,12.3-12.2,12.3s-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C115.5,209.4,121,203.9,127.7,203.9 M127.7,193.9c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S140,193.9,127.7,193.9L127.7,193.9z"
      fill="currentColor"
    />
    <path
      d="M209.7,203.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C197.5,209.4,203,203.9,209.7,203.9 M209.7,193.9c-12.3,0-22.2,10-22.2,22.2s10,22.2,22.2,22.2s22.2-10,22.2-22.2 S222,193.9,209.7,193.9L209.7,193.9z"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M209.7,203.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C197.5,209.4,203,203.9,209.7,203.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M127.7,203.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C115.5,209.4,121,203.9,127.7,203.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M46.7,203.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C34.5,209.4,40,203.9,46.7,203.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M209.7,84.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C197.5,90.4,203,84.9,209.7,84.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M127.7,84.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C115.5,90.4,121,84.9,127.7,84.9"
      fill="currentColor"
    />
    <path
      className="st0"
      d="M46.7,84.9c6.8,0,12.3,5.5,12.3,12.2c0,6.8-5.5,12.3-12.2,12.3c-6.8,0-12.3-5.5-12.3-12.2c0,0,0,0,0,0 C34.5,90.4,40,84.9,46.7,84.9"
      fill="currentColor"
    />
    <path d="M227.5,146.6v23h-199v-23H227.5 M237.5,136.6h-219v43h219V136.6z" fill="currentColor" />
    <path className="st0" d="M227.5,146.6v23h-199v-23H227.5" fill="currentColor" />
  </SvgIcon>
)) as React.FC<React.ComponentPropsWithRef<typeof SvgIcon>>;

export default ClassroomDuotone;
